

import { useMsal } from '@azure/msal-react';
import { Fragment, useEffect } from "react";
import Header from '../../nav/Header';
import HomePage from './HomePage';
import { useMatomo } from '@datapunt/matomo-tracker-react';


function Home() {
    return (
        <Fragment>
            <Header/>
            <HomePage/>
        </Fragment>

    )
}
export default Home;
